import type { ComponentStyleConfig } from '@chakra-ui/react';

export const Slider: ComponentStyleConfig = {
  sizes: {
    xl: {
      height: '12px',
    },
  },
};
